import CustomerCredit from './CustomerCredit'

import {
  Container,
  SubTitle,
  LabelRow,
  InfoText
} from './styles'

export default function CustomerCreditList ({
  credits = [],
  styles,
  onEdit: handleEdit = () => {},
  onDelete: handleDelete = () => {},
  onCloseBill: handleCloseBill = () => {}
}) {
  if (credits.length === 0) return (
    <Container style={styles}>
      <InfoText>
        Este cliente ainda não possui créditos ou dívidas
      </InfoText>
    </Container>
  )

  return (
    <Container style={styles}>
      <LabelRow>
        <SubTitle>Data</SubTitle>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Valor</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {credits.map (credit => (
        <CustomerCredit
          key={credit.id}
          data={credit}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onCloseBill={handleCloseBill}
        />
      ))}
    </Container>
  )
}
